// extracted by mini-css-extract-plugin
export default {"containerDomainEmailAccounts":"DomaineEmailAccounts_containerDomainEmailAccounts__RyXsW"};